module.exports = __webpack_public_path__ + "static/img/9.19e4262.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/sp/9.png
// module id = 2X51
// module chunks = 0